import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { Button, Checkmark } from "nzk-react-components"
import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  position: relative;
  z-index: 0;
  color: #fff;
  background-image: linear-gradient(
    -30deg,
#b12c74 0%,
#80138d 40%,
#351778 80%
    );
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  margin-bottom: 120px;

  .bottom-mask {
    z-index: -1;
    position: absolute;
    bottom: 0;
    margin-bottom: -1px;
    left: 0;
    width: calc(100% + 2px);
    display: flex;
    align-items: flex-end;
    img {
      width: 100%;
      height: 100%;
      object-position: bottom center;
      object-fit: cover;
    }
  }

> .content {
    display: flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    padding-bottom: 60px;
    /* max-width: 1000px; */
    margin: 0 auto;

    > .content--information {
      padding-bottom: 40px;
      max-width: 500px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: fit-content;
    }

    h1 {
      font-size: 2.6em;
      font-weight: bold;
    }

    ul { 
      padding: 0; 
      list-style-type: none;
      display: flex;
      flex-direction: column;
      gap: 1em;
    }
    li {
      display: flex;
      align-items: flex-start;
      gap: 0.25em;
      margin: 0;
      line-height: 1.2;
      font-size: 1.2em;
      text-align: left;
      .keypoint--icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        height: 1.2em;
        color: #fff !important;
        font-weight: bolder;
        svg {
          height: 30px;
          width: 30px;
        }
      }
    }

    .cta {
      /* margin: 0 auto; */
      margin-top: 10px;
      width: fit-content;
    }
  }

  .hero {
      /* flex: 1; */
    .hero--inner {
      display: flex;
      justify-content: flex-end;
    }
  }


  .cta-information {
    font-size: 0.8em;
    text-align: center;
  }

    ::before {
      position: absolute;
      content: '';
      bottom:0;
      left:0;
      width:  100%;
      height: 5px;
      background-color: #ece7f0;
    }


  @media screen and (max-width: 1179px) {
    margin-bottom: 0px;
    background-size: cover;
    background-position: center bottom;
    background-repeat: no-repeat;


    .content {
      padding-top: 40px;
      padding-bottom: 150px;
      gap: 30px;
      text-align: center;
      flex-direction: column-reverse;

      h1 {
        font-size: 2.1em !important;
        margin: 0; 
      }

      ul {
        margin: 0; 
      }

      li {
        display: block;
        text-align: center;
      }

      li .keypoint--icon {
        display: inline-flex;
        vertical-align: top;
        margin-right: 0.25em;
      }

      li .keypoint--text {
        display: inline;
      }

    .cta {
        text-align: center;
        margin-top: 20px;
    }

    }

    .content > .content--information {
      text-align: center;
      /* max-width: 360px; */
      padding: 0 20px;
      min-width: initial;
      margin: 0 auto;
      width: initial;
      flex-direction: column;
      align-items: center;

      gap: 1em;
    }




  .hero {
      display: flex;
      justify-content: center;
      .hero--inner {
        width: 250px;
        justify-content: center;
      }

  }
`

export const ParentsV2_EngagingBanner = (props: {
  cta: {
    label: string
    url: string
  }
}) => {
  return (
    <Wrapper>
      <div className="content">

        <div className="hero">
          <div className="hero--inner">
            <StaticImage src='../../../images/gang-behind-device-glow.png' alt='Logo' height={380} placeholder='blurred' />
          </div>
        </div>
        <div className="content--information">
          {/* <div>Trust pilot</div> */}
          <h1 className="desktop">Make Reading & Writing Fantastically Fun!</h1>
          <h1 className="mobile">
            Make<br />Reading & Writing <br />Fantastically Fun!
          </h1>
          {/* <p className="headline">{props.headLine}</p> */}

          <ul className="points">
            <li>
              <span className='keypoint--icon'> <Checkmark /> </span>
              <span className="keypoint--text">Award winning reading & writing program for ages 6-12</span>
            </li>
            <li>
              <span className='keypoint--icon'> <Checkmark /> </span>
              <span className="keypoint--text">Improves spelling, grammar, punctuation & vocabulary</span>
            </li>
            <li>
              <span className='keypoint--icon'> <Checkmark /> </span>
              <span className="keypoint--text">Trusted by parents, loved by children worldwide</span>
            </li>
          </ul>

          {props.cta && (
            <div className="cta">
              <Link to={props.cta.url}>
                <Button size="regular">{props.cta.label}</Button>
              </Link>
              <div className="cta-information">
                No commitment, cancel anytime.
              </div>
            </div>
          )}
        </div>

      </div>

      <div className="desktop">
        <div className="bottom-mask">
          <img src="/images/parents-v2/inverted-curve-desktop.svg" />
        </div>
      </div>
      <div className="mobile">
        <div className="bottom-mask">
          <img src="/images/parents-v2/inverted-curve-mobile.svg" />
        </div>
      </div>
    </Wrapper>
  )
}
